import { Config } from "../../../../api/config";
export var PSGKeys = {
    getDashboardAFR: "DashboardCountAFR",
    getDashboardIR: "DashboardCountIR",
    updateAFRDashboard: "AFRupdateDashboard",
    updateIRDashboard: "IRupdateDashboard",
    PagingIR: 'IRReportsPaging',
    count: 'IRReportsCount'
};
export var getAFRDashboard = "".concat(Config.baseURL, "AreaFieldReport/DashboardCountForPSG");
export var getIRDashboard = "".concat(Config.baseURL, "IntensiveReport/DashboardCountForPSG");
export var updateaAFRDashboardCount = "".concat(Config.baseURL, "AreaFieldReport/DashboardCountForPSG");
export var updateIRDashboardCount = "".concat(Config.baseURL, "IntensiveReport/DashboardCountForPSG");
export var IRPagingURL = "".concat(Config.baseURL, "IntensiveReport/Paging");
